import { MemberNotification } from "@/App/api/notification";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import DOMPurify from "dompurify";
import { FC, useMemo } from "react";

export const GeneralMessage: FC<{ readonly memberNotification: MemberNotification }> = ({ memberNotification }) => {
  const sanitizedHtmlMessage = useMemo(() => {
    return DOMPurify.sanitize(memberNotification.message);
  }, [memberNotification]);

  return (
    <Stack testId="general-message-container">
      { }
      <div role="main" dangerouslySetInnerHTML={{ __html: sanitizedHtmlMessage }}></div>
    </Stack>
  );
};
